module.exports = __webpack_public_path__ + "img/wet-street-night-thumb.01933a8d.jpg";